import { LitElement, html, css } from 'lit'
import { eventOptions } from 'lit/decorators.js'
export class AddButton extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }
    `,
  ]

  static properties = {
    //id: { type: String },
    variantId: { type: Number, attribute: 'variant-id' },
    productId: { type: Number, attribute: 'product-id' },
    soldOut: { type: Boolean, attribute: 'sold-out' },
    quantity: { type: Number, attribute: 'quantity' },
    isSubscription: { type: Boolean, attribute: 'is-subscription' },
  }

  constructor() {
    super()
    this.soldOut = this.soldOut ?? false
    this.subscriptions = null
    this.quantity = this.quantity ?? 1
  }

  connectedCallback() {
    super.connectedCallback()
    // if(this.id === 'main-add-to-cart') {
    // window.MicroBus.on('flavor:change', ({ detail }) => {
    //   console.log('detail', detail)
    //   if(detail.subscriptions) {
    //   this.subscription = detail.subscriptions.original_to_hidden_map[this.variantId].discount_variant_id
    //   }
    // })
    // }
  }

  renderButton() {
    console.log(this.soldOut)
    if (this.soldOut) {
      return html` <slot part="button" disabled="true"></slot> `
    } else {
      return html` <slot @click=${this._onClick}> </slot>`
    }
  }
  render() {
    return html` ${this.renderButton()} `
  }

  _onClick(e) {
    let data = {
      variant_id: this.variantId,
      quantity: this.quantity,
    }

    if (this.isSubscription) {
      const productData = window.Flavors.find((el) => el.product.id == this.productId)
      const { product, subscriptions } = productData

      data.variant_id = subscriptions.original_to_hidden_variant_map[this.variantId].discount_variant_id
      data.properties = {
        discount_percentage: subscriptions.discount_percentage,
        is_subscription: true,
        original_variant_id: this.variantId,
        handle: product.handle,
        shipping_interval_frequency: '1',
        shipping_interval_unit_type: subscriptions.shipping_interval_unit_type,
        subscription_id: subscriptions.subscription_id,
      }
    }

    window.MicroBus.emit('cart:add', data)
    if ($(this).attr('data-toggle') != 'false') {
      window.MicroBus.emit(`side-cart:toggle`)
    }
    e.preventDefault()
  }
}
customElements.define('add-button', AddButton)
